import {StandardAction} from './standard-action';

export class PagingAction extends StandardAction {
  /**
   * Current page
   */
  public page: number;
  /**
   * Current step size
   */
  public step: number;
  /**
   * Number of element
   */
  public count: number;
  /**
   * Available sizes
   */
  public sizes: number[] = [1, 5, 10, 15, 20, 25];
  /**
   * Is the size drop-down open ?
   */
  public isOpened = false;
  /**
   * User to display dots between arrows according to the number of page
   */
  public tab: number[] = [];

  constructor(name: string, align?: 'right'|'left'|'center') {
    super(name, null, null, null, align ?? 'right');
    this.category = 'paging';
  }

}

